var _module_exports = "<span>Profile picture was updated.</span>";;
var path = 'views/flashes/avatar_updated.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;